@if(activeModal) {
  <div class="modal-header">
    <h5 class="modal-title">{{ isEdit ? 'Edit Page' : 'Add New Page' }}</h5>
    <button type="button" class="btn-close ms-auto" (click)="closeModal()"></button>
  </div>
}

<div class="main-content" [ngClass]="{'modal-body bg-light': activeModal}">
  <div class="panel">
    @if (!activeModal) {
      <div class="panel-header">
        <h5 class="fw-bold">{{ isEdit ? 'Edit Page' : 'Add New Page' }}</h5>
      </div>
    }
  
    <div class="panel-body">
      <form #pageForm="ngForm" (ngSubmit)="addPage()">
    
        <!-- PAGE DETAILS -->
        <div class="panel mb-30">
          <div class="panel-header">
            <h5>Page Details</h5>
          </div>
          <div class="panel-body">
    
            <!-- Title -->
            <div class="mb-3">
              <label class="form-label">Title*</label>
              <input type="text" class="form-control" name="title" [(ngModel)]="newPage.title" #title="ngModel" required>
    
              @if (title.invalid && title.touched) {
              <div class="text-danger">
                Title is mandatory.
              </div>
              }
            </div>
    
            <!-- Description -->
            <div class="panel mb-30 border">
              <div class="panel-header">
                <h5 class="mb-0">Description*</h5>
                <div class="btn-box d-flex gap-2 align-items-center">
                  <button type="button" class="btn btn-sm"
                    [ngClass]="elementorMode.description ? 'btn-primary' : 'btn-outline-primary'"
                    (click)="openVisualEditor('description', elementorModal)">
                    <i class="fa fa-cubes me-1"></i> Visual Builder
                  </button>
                </div>
              </div>
              <div class="panel-body">
                @if (elementorMode.description) {
                  <div class="elementor-preview-container position-relative border rounded bg-light p-3 mb-2 cursor-pointer" 
                       (click)="openVisualEditor('description', elementorModal)">
                    <div [innerHTML]="getSafeHtml(newPage.description)" class="elementor-content-preview"></div>
                    <div class="elementor-edit-overlay">
                      <button type="button" class="btn btn-primary btn-sm">
                        <i class="fa fa-cubes me-1"></i> Edit with Visual Builder
                      </button>
                    </div>
                  </div>
                  <div class="text-end">
                    <button type="button" class="btn btn-link btn-sm text-muted p-0" (click)="elementorMode.description = false">
                      Switch to Standard Editor
                    </button>
                  </div>
                } @else {
                  <ce-custom-editor
                    name="description"
                    [(ngModel)]="newPage.description"
                    #description="ngModel"
                    required
                    [uploadFn]="handleImageUpload">
                  </ce-custom-editor>
                  
                  @if (description.invalid && description.touched) {
                  <div class="text-danger">
                    Description is mandatory.
                  </div>
                  }
                }
              </div>
            </div>
    
            <!-- Slug -->
            <div class="mb-3">
              <label class="form-label">Slug*</label>
              <input type="text" class="form-control" name="slug" [(ngModel)]="newPage.slug" #slug="ngModel" required (input)="onSlugChange()">
    
              @if (slug.invalid && slug.touched) {
              <div class="text-danger">
                Slug is mandatory.
              </div>
              }
            </div>
    
            <!-- Page Content -->
            <div class="panel mb-30 border">
              <div class="panel-header">
                <h5 class="mb-0">Page Content</h5>
                <div class="btn-box d-flex gap-2 align-items-center">
                  <button type="button" class="btn btn-sm"
                    [ngClass]="elementorMode.pageContent ? 'btn-primary' : 'btn-outline-primary'"
                    (click)="openVisualEditor('pageContent', elementorModal)">
                    <i class="fa fa-cubes me-1"></i> Visual Builder
                  </button>
                </div>
              </div>
              <div class="panel-body">
                @if (elementorMode.pageContent) {
                  <div class="elementor-preview-container position-relative border rounded bg-light p-3 mb-2 cursor-pointer" 
                       (click)="openVisualEditor('pageContent', elementorModal)">
                    <div [innerHTML]="getSafeHtml(newPage.pageContent)" class="elementor-content-preview"></div>
                    <div class="elementor-edit-overlay">
                      <button type="button" class="btn btn-primary btn-sm">
                        <i class="fa fa-cubes me-1"></i> Edit with Visual Builder
                      </button>
                    </div>
                  </div>
                  <div class="text-end">
                    <button type="button" class="btn btn-link btn-sm text-muted p-0" (click)="elementorMode.pageContent = false">
                      Switch to Standard Editor
                    </button>
                  </div>
                } @else {
                  <ce-custom-editor
                    name="pageContent"
                    [(ngModel)]="newPage.pageContent"
                    [uploadFn]="handleImageUpload">
                  </ce-custom-editor>
                }
              </div>
            </div>
    
          </div>
        </div>
    
        <!-- SEO SECTION -->
        <div class="panel mb-30">
          <div class="panel-header border">
            <h5>SEO Settings</h5>
          </div>
          <div class="panel-body">
    
            <!-- Focus Keyphrase -->
            <div class="mb-3">
              <label class="form-label">Focus Keyphrase</label>
              <input type="text" class="form-control" name="keywords" [(ngModel)]="newPage.seoData.keywords">
            </div>
    
            <!-- SEO Meta Title -->
            <div class="mb-3">
              <label class="form-label">SEO Meta Title</label>
              <input type="text" class="form-control" name="metaTitle" [(ngModel)]="newPage.seoData.metaTitle">
            </div>
    
            <!-- SEO Meta Description -->
            <div class="mb-3">
              <label class="form-label">SEO Meta Description</label>
              <textarea class="form-control" rows="3" name="metaDescription"
                [(ngModel)]="newPage.seoData.metaDescription"></textarea>
            </div>
    
          </div>
        </div>
    
        <!-- SUBMIT -->
        <div class="text-end">
          <button class="btn btn-primary" type="submit" [disabled]="pageForm.invalid">
            {{ isEdit ? 'Update Page' : 'Add Page' }}
          </button>
        </div>
    
      </form>
    </div>
  </div>
</div>

<ng-template #elementorModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Visual Builder - {{ currentEditingField === 'description' ? 'Description' : 'Page Content' }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <app-elementor-editor
      [(ngModel)]="tempElementorValue"
      [uploadFn]="handleImageUpload">
    </app-elementor-editor>
  </div>
  <div class="modal-footer gap-2">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="modal.close('save')">Done</button>
  </div>
</ng-template>

